import React, {useEffect, useRef, useState} from "react";
import spinner from "../../../assets/lotties/spinner.json";

import {Button, Divider, Input, message, Modal} from "antd";
import {useTranslation} from "react-i18next";
import PlanItem from "./PlanItem";
import {GetListParams, IClusterPlanLongItem, IClusterPlanShortItem} from "../../../api/apiTypes";
import InfiniteList from "../../molecules/list/InfiniteList";
import {showApiError, showMessage,} from "../../../common/message";
import Lottie from "lottie-react";
import http from "../../../services/http.service";
import {queries} from "../../../api/queries";
import {useDebounce} from "../../../services/useDebounce";
import {DraggableModal} from "../../molecules/DraggableModal";

export interface SearchParams extends GetListParams {
  sector_code?: string;
  sector_code__in?: string[];
  cluster_id__startswith?: string;
}

interface Props {
  onMerged: () => void;
  onHide: () => void;
  plan: IClusterPlanLongItem;
  params: SearchParams;
}

export const MergePlanPopup = ({
                                 plan, onMerged, onHide, params: paramsProp,
                               }: Props) => {
  const {t} = useTranslation("shipping");
  const [selectedPlan, setSelectedPlan] = useState<IClusterPlanShortItem>();
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, messageHolder] = message.useMessage();
  const [params, setParams] = useState<SearchParams>({
    page_size: 20, ...paramsProp,
  });
  const inputValueRef = useRef("");
  
  useEffect(() => {
    if (paramsProp) setParams((prev) => ({...prev, ...paramsProp}));
  }, [paramsProp]);
  
  const handleMerge = (e: any) => {
    if (!!selectedPlan) {
      if (selectedPlan.merge_allowed) {
        showMessage(messageApi, t("Please, select a plan not sorted"), "warning");
      }
      else {
        setIsLoading(true);
        http
        .post(queries.plan.merge(selectedPlan.id), {src_plan_id: plan.id})
        .then(onMerged)
        .catch((e) => {
          showApiError(e, messageApi);
        })
        .finally(() => {
          setIsLoading(false);
        });
      }
    }
    else {
      showMessage(messageApi, "Please, select plan to be merged");
    }
  };
  
  const debouncedChange = useDebounce((inputValue) => {
    console.log('Debounced:', inputValue);
    setParams((prev) => ({
      ...prev, cluster_id__startswith: inputValueRef.current,
    }));
  }, 1000);
  
  const handleSearch = (e) => {
    if (e.target.value) inputValueRef.current = e.target.value;
    debouncedChange(inputValueRef.current);
  };
  
  const buttonNode = (<div className={"footer"}>
    <Button
      type={"text"}
      className={"cancel"}
      onClick={onHide}
    >
      {t("popup.btn.back")}
    </Button>
    <Divider type={"vertical"} className={"divider"} />
    <Button
      type={"text"}
      className={"ok"}
      onClick={handleMerge}
    >
      {t("merge plan")}
    </Button>
  </div>);
  
  return (<DraggableModal
    closable={false}
    cancelText={""}
    open
    maskClosable
    centered
    width={335}
    className={"sm-modal"}
    classNames={{body: "body", content: "content", footer: "footer"}}
    footer={buttonNode}
  >
    {messageHolder}
    <div className={"title"}>
      {t("merge plan")}
    </div>
    <Input
      onChange={handleSearch}
      size={"small"}
      className={"input"}
      placeholder={t("search plan")}
      autoComplete={"off"}
      suffix={<Button
        type={"text"}
        size={"small"}
        color={"primary"}
        onClick={handleSearch}
        className={"button"}
      >
        {t("search")}
      </Button>}
    />
    <InfiniteList<IClusterPlanShortItem>
      url={queries.plan.short}
      params={params}
      height={300}
      itemSize={46}
      shouldRender={(p) => plan.id !== p.id}
      renderItem={(p, style) => (<PlanItem
        key={"rider" + p.id}
        style={style}
        selected={p.id === selectedPlan?.id}
        plan={p}
        onSelect={(selected) => setSelectedPlan(selected)}
      />)} />
    {isLoading && (<Lottie animationData={spinner} className={"spinner"} loop autoplay style={{height: 25}} />)}
  </DraggableModal>);
};
